<div class="card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="codes"
      [totalRecords]="codes.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
    <div *ngIf="!loading" class="px-3 py-2">
      <span class="small text-muted">{{ codes.length }} {{ 'Settings::WorkEnvironment:WrapupCodes:CodeCount' | abpLocalization }}</span>
    </div>
  </div>
</div>

<ng-template #nameTpl let-row>
  <span>{{ getDisplayName(row) }}</span>
</ng-template>

<ng-template #descriptionTpl let-row>
  <div
    #descriptionEl
    class="text-truncate"
    style="max-width: 22rem"
    [pTooltip]="isTruncated(descriptionEl) ? row.description : ''"
    tooltipPosition="top"
    appendTo="body">
    {{ row.description }}
  </div>
</ng-template>

<ng-template #policyTpl let-row>
  <span>{{ getPolicyLabel(row) }}</span>
</ng-template>

<ng-template #queuesTpl let-row>
  <ng-container *ngIf="row.queues?.length; else noQueues">
    <div class="d-flex flex-wrap gap-2 align-items-center">
      <p-tag *ngFor="let q of getQueuesInline(row)" [value]="q.name"></p-tag>
      <span
        *ngIf="hasQueuesOverflow(row)"
        class="d-inline-flex align-items-center"
        [pTooltip]="getQueuesOverflowTooltip(row)"
        tooltipPosition="top"
        appendTo="body">
        <p-tag [value]="'+' + getQueuesOverflowCount(row)"></p-tag>
      </span>
    </div>
  </ng-container>
  <ng-template #noQueues>
    <span class="text-muted">—</span>
  </ng-template>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>
